import { Photo } from '@types';
import { LOCATIONS } from '@utils/locations';

const PARIS_2024_06_02_SELFIE: Photo = {
  id: 'paris_2024_06_02_selfie',
  date: '2024/06/02',
  location: LOCATIONS.PARIS,
};

export default PARIS_2024_06_02_SELFIE;
